"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translateXY = exports.transition = exports.opacity = exports.colors = void 0;
var colors = {
  alabaster: '#FAFAFA',
  alto: '#DEDEDE',
  black: '#000000',
  codGray: '#141414',
  dodgerBlue: '#2AB0FE',
  iron: '#E6E7E8',
  pavlova: '#D7C097',
  pomegranate: '#EE3133',
  sunglow: '#FFDB2A',
  sunsetOrange: '#FF5157',
  transparent: 'transparent',
  transparentBlack: 'rgba(0, 0, 0, 0)',
  white: '#FFFFFF',
  whiteRock: '#ECE7D9'
};
exports.colors = colors;
var opacity = 1;
exports.opacity = opacity;
var transition = 'all 200ms ease';
exports.transition = transition;
var translateXY = 'translate(-50%, -50%)';
exports.translateXY = translateXY;